import PropTypes from "prop-types";
import React, { Fragment } from "react";
// import { withRouter, matchPath } from "react-router";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from "react-html-parser";

import Link from "../../../../components/Link";
// ^^ A Link element for our custom history router.

import PopupPageDecoration from "../../../../views/HomeView/PopupPages/PopupPageDecoration";

import Form, { FormRow, UploadButton, TextField, SubmitButton } from "../../../../components/Form";

import SEO from "../../../../../../global-components/seo";

import * as ROUTES from "../../../../constants/routes.js";

import "./style.scss";

class SubmissionErrorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentReady: false,
    };

    this.vars = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  /* componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.currentRoute !== prevProps.currentRoute) {
      //
    }
  } */

  init = () => {
    const Z = this;

    // We can skip this because the page content is minimal:
    /* if (Z.props.setReady != null) {
        Z.props.setReady(false);
      }
      Z.setState({
        contentReady: false,
    }); */

    if (Z.props.setReady != null) {
      Z.props.setReady(Z.props.componentRoute, true);
    }
    Z.setState({
      contentReady: true,
    });
  };

  render() {
    var Z = this;

    // var greenhouseError = "Failed to reach server"; // Get error here.. or somewhere
    var greenhouseError = Z.props.formError;

    return (
      <PopupPageDecoration isVertical={true}>
        <div className={`SubmissionErrorPage`}>
          <div className="page-title-row">
            <div className="page-title">Oh no :(</div>
          </div>
          <div className="page-description">
            <p>There was an error submitting your application.</p>
            <p>Please try again:</p>
            <p>
              <Link to=".back" className="go-back-button">
                Go back
              </Link>
            </p>
            {greenhouseError && greenhouseError.status != 0 ? (
              <p className="error-text">
                Error: {greenhouseError.status} - {greenhouseError.error}
              </p>
            ) : null}
          </div>
          <div className="page-bottom-space"></div>
        </div>
      </PopupPageDecoration>
    );
  }
}

SubmissionErrorPage.propTypes = {
  // currentPage: PropTypes.string,
  // roleId: PropTypes.string,
  componentRoute: PropTypes.string,
  currentRoute: PropTypes.object,
  setReady: PropTypes.func,
  formError: PropTypes.object,
};

export default SubmissionErrorPage;
